/* A column so the dialog can shrink to the popover's height. react-aria sets an
   inline max-height on this element — the room left between the trigger and the
   viewport edge — but without the dialog below scrolling inside it, content
   taller than that room spilled straight past the popover and off the screen. */
.popover {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color__gray-300);
  border-radius: var(--border-radius__xs);
  background-color: var(--color__white);
  color: var(--color__gray-800);
  outline: none;
  transition: opacity 1000ms;
}

.popover[data-entering] {
  animation: show 200ms;
}

.popover[data-exiting] {
  animation: show 200ms reverse ease-in;
}

/* `min-block-size: 0` is what lets a flex item shrink below its content; the
   overflow then scrolls here, and the arrow — which sits outside the box — is left
   unclipped. The inset is this element's padding rather than the popover's: a
   scroll box clips at its padding edge, and the design-system type is trimmed to
   its baseline, so with no padding inside the scroller the last line's descenders
   would hang past that edge and be cut off. */
.dialog {
  outline: none;
  min-block-size: 0;
  overflow-y: auto;
  padding: var(--space__lg);
}

.popover[data-placement='top'] {
  box-shadow: 0 1px 4px rgba(0 0 0 / 0.1);
  margin-block-end: 6px;
}

.popover[data-placement='bottom'] {
  box-shadow: 0 -1px 4px rgba(0 0 0 / 0.1);
  margin-block-start: 6px;
}

.popover[data-placement='right'] {
  box-shadow: -1px 0 4px rgba(0 0 0 / 0.1);
  margin-inline-start: 6px;
}

.popover[data-placement='left'] {
  box-shadow: 1px 0 4px rgba(0 0 0 / 0.1);
  margin-inline-end: 6px;
}

.arrow > svg {
  display: block;
  fill: var(--color__white);
  stroke: var(--color__gray-300);
  stroke-width: 1px;
}

.arrow[data-placement='right'] > svg {
  transform: rotate(90deg);
}

.arrow[data-placement='bottom'] > svg {
  transform: rotate(180deg);
}

.arrow[data-placement='left'] > svg {
  transform: rotate(-90deg);
}

@keyframes show {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
